module.exports = __webpack_public_path__ + "static/media/verizon-poster.d1c20c3b.png";